import React, { useEffect, useState } from 'react'
import apiTools from '../ApiData/SkillsTools.json'
import ToolsApi from './ToolsApi';
import aos from "aos";
import "aos/dist/aos.css";
const Tools = () => {
    document.title="💻 Tools | Rian Islam"

    useEffect(() => {
        aos.init({ duration: 2000 });
      }, []);

    const [tools,setTools] = useState([]);
    useEffect(() =>{
        setTools(apiTools.tools);
        console.log(apiTools.tools)
    },[])

    return (
        <div className="container py-5">

<h1 data-aos="fade-left" className="text-center pt-5">Tools</h1>
        <p data-aos="fade-right" className="text-center pb-5">My weapons of choice to help tackle any Projects</p>


        <div  data-aos="fade-up" className="row g-4">
        {tools.map( (tl) => <ToolsApi tool={tl}/>)}
        </div>
            
        </div>
    )
}

export default Tools
